import axios from 'axios';
import { getMarketsUrl } from '../endpoints/market';

export const getMarkets = async () => {
    const result = await axios.get<MarketWithLanguages[]>(getMarketsUrl);
    return result.data;
};
